import { IInstructions } from '../../interfaces/connection.interfaces'
import { ConnectionSetupInstructionContainer } from './connection-setup-instruction-container'
import { ConnectionSetupInstructionTitle } from './connection-setup-instruction-title'

type ConnectionSetupInstructionProps = {
  instrunctionsType: string
  instrunctions: Array<IInstructions>
  credentials?: boolean
}

export const ConnectionSetupInstruction = ({
  instrunctions,
  instrunctionsType,
  credentials = false,
}: ConnectionSetupInstructionProps) => {
  return (
    <>
      {instrunctions?.map((instruction) => {
        return (
          <ConnectionSetupInstructionContainer
            credentials={credentials}
            instructionType={instrunctionsType}
            key={instruction?.step}
          >
            <ConnectionSetupInstructionTitle
              credentials={credentials}
              instruction={instruction}
              instructionType={instrunctionsType}
            />
            {instruction?.has_sub_instructions && (
              <ConnectionSetupInstructionContainer
                credentials={credentials}
                instructionType={instruction?.sub_instructions_type}
              >
                {instruction?.sub_instructions?.map((subInstruction) => {
                  return (
                    <>
                      <ConnectionSetupInstructionTitle
                        credentials={credentials}
                        instruction={subInstruction}
                        instructionType={instruction?.sub_instructions_type}
                        key={subInstruction?.step}
                      />
                      {subInstruction?.has_sub_instructions && (
                        <ConnectionSetupInstructionContainer
                          credentials={credentials}
                          instructionType={instruction?.sub_instructions_type}
                        >
                          {subInstruction?.sub_instructions?.map(
                            (subInstruction) => {
                              return (
                                <ConnectionSetupInstructionTitle
                                  credentials={credentials}
                                  instruction={subInstruction}
                                  instructionType={
                                    instruction?.sub_instructions_type
                                  }
                                  key={subInstruction?.step}
                                />
                              )
                            },
                          )}
                        </ConnectionSetupInstructionContainer>
                      )}
                    </>
                  )
                })}
              </ConnectionSetupInstructionContainer>
            )}
          </ConnectionSetupInstructionContainer>
        )
      })}{' '}
    </>
  )
}
